import { MedicalPaOrdersAuthStatus } from "../../../../../enums/medicalPaOrdersAuthStatus";

const authStatusForWhichInputIsAllowed = [
  MedicalPaOrdersAuthStatus.AuthByRISA,
  MedicalPaOrdersAuthStatus.AuthOnFile,
  MedicalPaOrdersAuthStatus.NoAuthRequired,
  MedicalPaOrdersAuthStatus.AuthRequired,
  MedicalPaOrdersAuthStatus.Pending,
  MedicalPaOrdersAuthStatus.DeniedByRISA,
  MedicalPaOrdersAuthStatus.DenialByRISA,
  MedicalPaOrdersAuthStatus.ExistingDenial,
];

export const determineIfTheJCodeFieldShouldBeEditable = (
  authStatus: string,
  jCode: string,
) => {
  const determineIfJCodeRequiresInput = jCode.trim() === "";
  const isAuthStatusValid = authStatusForWhichInputIsAllowed.includes(
    authStatus as MedicalPaOrdersAuthStatus,
  );
  return determineIfJCodeRequiresInput && isAuthStatusValid;
};
